import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title col-sm-9" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-group col-sm-6" }
const _hoisted_16 = { for: "name" }
const _hoisted_17 = { class: "form-group col-sm-6" }
const _hoisted_18 = { for: "email" }
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = { class: "form-group col-12 col-sm-4" }
const _hoisted_21 = { for: "accept_newsletter" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "form-group col-12 col-sm-4" }
const _hoisted_24 = { for: "accept_terms_use" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "form-group col-12 col-sm-4" }
const _hoisted_27 = { for: "enabled" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "card-tools" }
const _hoisted_30 = { class: "card-tools" }
const _hoisted_31 = ["title"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["title"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "card-body table-body" }
const _hoisted_38 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_39 = { class: "btn-group" }
const _hoisted_40 = ["onClick", "title"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick", "title"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick", "title"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")
  const _component_table_lite = _resolveComponent("table-lite")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.customer")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.customer")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filterCustom.name) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterCustom.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("labels.entity.email")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterCustom.email) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterCustom.email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("labels.entity.acceptNewsletter")), 1),
                  _hoisted_22,
                  _createVNode(_component_Toggle, {
                    modelValue: _ctx.filterCustom.accept_newsletter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filterCustom.accept_newsletter) = $event)),
                    "on-label": _ctx.$t('labels.yes'),
                    "off-label": _ctx.$t('labels.no')
                  }, null, 8, ["modelValue", "on-label", "off-label"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("labels.entity.acceptTermsUse")), 1),
                  _hoisted_25,
                  _createVNode(_component_Toggle, {
                    modelValue: _ctx.filterCustom.accept_terms_use,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filterCustom.accept_terms_use) = $event)),
                    "on-label": _ctx.$t('labels.yes'),
                    "off-label": _ctx.$t('labels.no')
                  }, null, 8, ["modelValue", "on-label", "off-label"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("labels.entity.active")), 1),
                  _hoisted_28,
                  _createVNode(_component_Toggle, {
                    modelValue: _ctx.filterCustom.enabled,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.filterCustom.enabled) = $event)),
                    "on-label": _ctx.$t('labels.yes'),
                    "off-label": _ctx.$t('labels.no')
                  }, null, 8, ["modelValue", "on-label", "off-label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-info",
                  onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                }, _toDisplayString(_ctx.$t('labels.search')), 1),
                _createTextVNode("   "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-default",
                  onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.clear && _ctx.clear(...args)))
                }, _toDisplayString(_ctx.$t('labels.buttons.clean')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                title: _ctx.$t('labels.buttons.reload')
              }, _hoisted_33, 8, _hoisted_31),
              _createTextVNode("   "),
              (_ctx.hasPermission('create'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "newButton",
                    class: "btn btn-sm btn-primary btn-new",
                    onClick: _cache[8] || (_cache[8] = $event => (_ctx.newRow())),
                    style: {"width":"33px"},
                    title: _ctx.$t('labels.buttons.new')
                  }, _hoisted_36, 8, _hoisted_34))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[9] || (_cache[9] = $event => (_ctx.table.isLoading = false))
            }, {
              accept_newsletter: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.accept_newsletter,
              'bg-danger': !props.value.accept_newsletter
            }])
                }, _toDisplayString(props.value.accept_newsletter ? _ctx.$t('labels.yes') : _ctx.$t('labels.no')), 3)
              ]),
              accept_terms_use: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.accept_terms_use,
              'bg-danger': !props.value.accept_terms_use
            }])
                }, _toDisplayString(props.value.accept_terms_use ? _ctx.$t('labels.yes') : _ctx.$t('labels.no')), 3)
              ]),
              enabled: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.enabled,
              'bg-danger': !props.value.enabled
            }])
                }, _toDisplayString(props.value.enabled ? _ctx.$t('labels.active') : _ctx.$t('labels.inactive')), 3)
              ]),
              actions: _withCtx((props) => [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.hasPermission('read'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: $event => (_ctx.view(props.value.id)),
                          class: "btn btn-xs btn-success",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.view')
                        }, _hoisted_42, 8, _hoisted_40))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('edit'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: $event => (_ctx.edit(props.value.id)),
                          class: "btn btn-xs btn-warning",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.edit')
                        }, _hoisted_45, 8, _hoisted_43))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('delete'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          onClick: $event => (_ctx.excluir(props.value.id)),
                          class: "btn btn-xs btn-danger",
                          "data-delay": "500",
                          "data-hasqtip": "1",
                          title: _ctx.$t('labels.buttons.remove')
                        }, _hoisted_48, 8, _hoisted_46))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}